import { render, staticRenderFns } from "./GeneralResultsTable.vue?vue&type=template&id=c80558e0&scoped=true"
import script from "./GeneralResultsTable.vue?vue&type=script&lang=js"
export * from "./GeneralResultsTable.vue?vue&type=script&lang=js"
import style0 from "./GeneralResultsTable.vue?vue&type=style&index=0&id=c80558e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80558e0",
  null
  
)

export default component.exports